import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import {setGroheFiltersOpened} from "../../../../../actions/groheFunctions";
import GroheFiltersSearchInputAsync from "./groheFiltersSearchInputAsync";
import {setSelectedFilters} from "../../../../../actions/actionFunctions";
import LookFiltersList from "../../../lookNavigation/lookFilters/lookFiltersList";
import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";


const GroheFilters = (props) => {
  const {filtersOpened, intl, isMobile, setGroheFiltersOpened, setSelectedFilters, lookOpened} = props;

  const closeFilterClick = () => {
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeaturesFiltersClose);
    setGroheFiltersOpened(!filtersOpened);
  };

  const resetFilterClick = () => {
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeaturesFiltersReset);
    setSelectedFilters([]);
  };

  if (!lookOpened) {
    return null
  }

  //console.log("availableFilters", availableFilters);

  return (
    <section className={"grohe-sidebar grohe-sidebar--filters" + (filtersOpened ? " grohe-sidebar--opened" : "")}>
      <div className="grohe-container grohe-container--no-top-padding grohe-filters grohe-filters--flex">
        <div className={"lk-title" + (isMobile ? " lk-title--centered" : "")}>
          <h2 className="lk-title__text"><FormattedMessage id={"grohe.filter.title"}/></h2>
          <IconButton aria-label={intl.formatMessage({id:"iconButton.close"})}
                      className="look-icon look-icon--small"
                      onClick={closeFilterClick}>
            <CloseIcon/>
          </IconButton>
        </div>
        <div className="lk-sub-title">
          <FormattedMessage id={"grohe.filter.subTitle"}/>
        </div>
        <GroheFiltersSearchInputAsync/>
        <LookFiltersList/>
        <div className="grohe-filters__buttons">
          <div className="lk-button grohe-lk__button">
            <Button className={"look-button look-button--primary grohe-look__button " + (isMobile ? " look-button--no-radius" : "")}
                    onClick={closeFilterClick}>
              <FormattedMessage id={"grohe.filter.close"}/>
            </Button>
          </div>
          <div className="lk-button grohe-lk__button">
            <Button className={"look-button grohe-look__button look-button--tertiary" + (isMobile ? " look-button--secondary look-button--no-radius" : "")}
                    onClick={resetFilterClick}>
              <FormattedMessage id={"grohe.filter.reset"}/>
            </Button>
          </div>
        </div>
      </div>
    </section>
  )
};

const mapStateToProps = (store) => {
  const {lookOpened} = store.lookState;
  const {filtersOpened} = store.groheState;
  const {isMobile} = store.serverState;
  return {
    filtersOpened,
    isMobile,
    lookOpened,
  };
};

const mapDispatchToProps = {
  setGroheFiltersOpened,
  setSelectedFilters,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(GroheFilters)
);
